export enum MARGIN_TRANSFER_SECTIONS {
  ISOLATED = 'isolated',
  CROSS = 'cross',
  FIAT_AND_SPOT = 'fiat_and_spot',
  FUNDING = 'funding',
}
